<template>
  <footer class="footer">
    <div class="container">
      <div class="row d-none d-sm-flex">
        <div class="col-6 versao">Versão: {{ versao }}</div>
        <div class="col-6 text-right">
          <div class="logo"></div>
        </div>
      </div>
      <div class="row d-sm-none">
        <div class="col-12 text-center">
          <div class="logo"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    versao: { type: String, default: "0.0.0" },
  },
};
</script>

<style scoped>
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 66px;
  line-height: 60px;
  background-color: #fff;
  color: #000;
  padding-bottom: 6px;
  font-family: DINPro-Regular, Arial, sans-serif;
}

.footer .logo {
  height: 50px;
  width: 160px;
  background-image: url('/imgs/logo-menu.svg');
  background-size: auto 100%;
  background-repeat: no-repeat;
  margin-top: 10px;
  float: right;
}
</style>